import * as React from 'react';
import { connect } from 'react-redux';
import {
    BaseContainer,
    BaseElement,
    Last30MinutesRealTimeReport,
    RevenueReport,
    UserByCountryReport,
    RetentionReport,
    OverviewReport,
    UsersByDayReport,
    Last30MinutesClientRequestReport,
} from '../components';
import { ContainerContext, mapProps } from './index';
import { Grid2 as Grid } from '@mui/material';
import { useNavigate } from 'react-router';
import { StateMap } from '../reducers';
import { Moment } from 'moment/moment';
import useMediaQuery from '@mui/material/useMediaQuery';

interface Props extends ContainerContext.Props {
    readonly selected?: Entities.UserTitleData;
}

interface State {
}

class Container extends BaseElement<Props, State> {
    state = {
    };

    protected renderContainer(): React.JSX.Element {
        return (
            <BaseContainer styled={this.props.styled}>
                {this.renderContent()}
            </BaseContainer>
        );
    }

    private renderContent = () => {
        const { selected } = this.props;

        return (
            <Grid container={true} justifyContent="center" spacing={3} style={{ margin: '20px 40px' }}>
                <Grid size={12}>
                    <OverviewReport styled={this.props.styled} />
                </Grid>
                {selected && selected.analyticsEnable && (
                    <>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                            <Last30MinutesClientRequestReport
                                styled={this.props.styled}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                            <Last30MinutesRealTimeReport
                                styled={this.props.styled}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                            <UsersByDayReport styled={this.props.styled} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                            <RevenueReport styled={this.props.styled} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                            <RetentionReport
                                styled={this.props.styled}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                            <UserByCountryReport styled={this.props.styled} />
                        </Grid>
                    </>
                )}
            </Grid>
        );
    };
}

const mapStateToProps = (state: StateMap): Props => ({
    ...mapProps(state),
    selected: state.title.selectedTitle,
});
const AppContainer = (props: Props) =>
{
    const smallUp = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    const navigate = useNavigate();
    return (<Container {...props} styled={{themeMode: props.app.themeMode, smallUp}} navigate={navigate} />);
};
export default connect(mapStateToProps)(AppContainer);
